import $ from 'jquery';
import { directiveSettings } from '../../utils/parse';
import { getScrollTop } from '../../utils/window';

/**
 * Sticks an element top the top of the screen.
 * TODO Allow for a sticky container to stop elements sticking too far.
 *
 * @param context
 */
export default function stickyDirective(context=document.body) {
    const $context = $(context);
    const $window = $(window);

    $context.find('[sw-sticky]').each(function() {
        const $element = $(this);
        const json = $element.attr('sw-sticky');
        const settings = directiveSettings(json, {
            name: '',
            offset: 0,
        }, 'name');

        let $filler = settings.name ? $context.find(`[sw-sticky-filler='${settings.name}']`) : $();
        if ($filler.length === 0) {
            $filler = $(`<div sw-sticky-filler="${settings.name}">`);
            $element.before($filler);
        }

        let isFixed = false;

        function fillerSize() {
            $filler.css('height', $element.outerHeight() + 'px');
        }

        function stickyScroll() {
            if (isFixed) {
                let fillerTop = $filler.offset().top + settings.offset;
                if (getScrollTop() <= fillerTop) {
                    isFixed = false;
                    fixSticky(false);
                }
            } else {
                let stickyTop = $element.offset().top + settings.offset;
                if (getScrollTop() > stickyTop) {
                    isFixed = true;
                    fixSticky(true);
                }
            }
        }

        function fixSticky(fix) {
            if (fix) {
                $filler.css('display', '');
                $element.addClass('is-stuck').removeClass('is-unstuck');
            } else {
                $filler.css('display', 'none');
                $element.removeClass('is-stuck').addClass('is-unstuck');
            }
        }

        fillerSize();
        fixSticky(false);
        stickyScroll();

        $window.on('resize', fillerSize);
        $window.on('resize scroll', stickyScroll);
    });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/scroll/sticky.js